import React from 'react';
import './PrioritizedFixList.css';

function PrioritizedFixList({ items }) {
  const list = items?.length ? items.slice(0, 10) : [];

  return (
    <div className="prioritized-fix-list">
      <h3>Top Priorities</h3>
      {list.length === 0 ? (
        <p>No priority items available.</p>
      ) : (
        <ol>
          {list.map((item, index) => (
            <li key={item.id || `${item.title}-${index}`}>
              <div className="priority-title">{item.title || item.name || 'Priority Item'}</div>
              <div className="priority-meta">
                <span>{item.category || 'General'}</span>
                <span className={`priority-severity priority-${(item.severity || 'low').toLowerCase()}`}>
                  {item.severity || 'Low'}
                </span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}

export default PrioritizedFixList;
